import { WhatsAppContact } from './whatsappContact';

export class SendWhatsAppContactInput {
  whatsAppContact: WhatsAppContact;
}
